import React from 'react';
import { Link } from 'react-router-dom'
import './PrivateFooter.css'

const SuperUserFooterUI = ({context}) =>
  <div className='t_pvt_footer g_flex_h'>
    <Link className='link' to='/su/accounts'>
      Accounts
    </Link>
    <Link className='link' to='/su/txns/pending'>
      Transactions
    </Link>
    <Link className='link' to='/su/settings'>
      Settings
    </Link>
  </div>

export default SuperUserFooterUI
